// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3572":"16cce045","5116":"5abbae87","6952":"7ce6db50"}[chunkId] + ".chunk.css";
};